// pages/Services.js
import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { APP_CONFIG } from "../app-config";
import SidebarHeader from "../components/SidebarHeader";
import BottomNav from "../components/bottom-menu";
import toast, { Toaster } from 'react-hot-toast';
import { FiArrowLeft } from "react-icons/fi";

// Import individual components
import MobileRecharge from "../components/MobileRecharge";
import DTHRecharge from "../components/DTHRecharge";
import RedeemCode from "../components/RedeemCode";
import BillPayment from "../components/BillPayment";

import Bmnemonic_PNG from "../assets/image/Bmnemonic_PNG.png";

const COLORS = APP_CONFIG.colors;

const serviceIcons = {
    phone: (color) => (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
            <line x1="12" y1="18" x2="12.01" y2="18" />
        </svg>
    ),
    dth: (color) => (
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 3a8 8 0 0 0-8 8" />
            <path d="M14 7a4 4 0 0 0-4 4" />
            <circle cx="14" cy="11" r="1.5" fill={color} stroke="none" />
            <rect x="4" y="17" width="16" height="4" rx="1" />
            <circle cx="7" cy="19" r="0.5" fill={color} stroke="none" />
            <circle cx="10" cy="19" r="0.5" fill={color} stroke="none" />
        </svg>
    ),
    gift: (color) => (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 12 20 22 4 22 4 12" />
            <rect x="2" y="7" width="20" height="5" />
            <line x1="12" y1="22" x2="12" y2="7" />
            <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z" />
            <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z" />
        </svg>
    ),
};

function Services() {
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState(location.state?.tab || 'mobile');
    const [balance, setBalance] = useState(localStorage.getItem("balance") || "0.00");
    const [selectedCategory, setSelectedCategory] = useState(location.state?.category || false);

    const tabs_list = [
        { id: 'mobile', label: 'Mobile Recharge', icon: serviceIcons.phone(COLORS.primaryColor) },
        { id: 'dth', label: 'DTH Recharge', icon: serviceIcons.dth(COLORS.primaryColor) },
        { id: 'redeem', label: 'Google Redeem Code', icon: serviceIcons.gift(COLORS.primaryColor) },
        {
            id: 'bill', label: 'Bill Payment', icon: (
                <img
                    src={Bmnemonic_PNG}
                    alt="Billpay"
                    style={{
                        width: 26,
                        height: 26,
                        objectFit: 'contain'
                    }}
                />
            )
        },
    ];

    const renderContent = () => {
        switch (selectedTab) {
            case 'mobile':
                return <MobileRecharge />;
            case 'dth':
                return <DTHRecharge />;
            case 'redeem':
                return <RedeemCode />;
            case 'bill':
                return <BillPayment category={selectedCategory} />;
            default:
                return <MobileRecharge />;
        }
    };

    return (
        <SidebarHeader>
            <div className="flex items-center gap-3 pb-4">
                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center justify-center w-10 h-10 rounded-xl bg-gray-200 hover:bg-gray-300 transition"
                >
                    <FiArrowLeft className="text-xl" />
                </button>
                <h1 className="text-lg font-semibold text-gray-800">
                    {tabs_list.find(tab => tab.id === selectedTab)?.label || ''}
                </h1>
            </div>
            <div className="max-w-7xl mx-auto mb-16">
                {/* Simple Tabs */}
                <div
                    className="mb-5 overflow-x-auto border-b"
                    style={{ borderColor: COLORS.borderColor }}
                >
                    <div className="flex min-w-max">
                        {tabs_list.map((tab) => {
                            const isActive = selectedTab === tab.id;

                            return (
                                <button
                                    key={tab.id}
                                    onClick={() => setSelectedTab(tab.id)}
                                    className="relative flex items-center gap-2 px-4 py-3 text-sm font-medium transition-all duration-200 whitespace-nowrap"
                                    style={{
                                        color: isActive
                                            ? COLORS.primaryColor
                                            : COLORS.textSecondary,
                                    }}
                                >
                                    {/* Icon */}
                                    <span
                                        className="flex items-center justify-center"
                                        style={{
                                            opacity: isActive ? 1 : 0.65,
                                        }}
                                    >
                                        {tab.icon}
                                    </span>

                                    {/* Label */}
                                    <span>{tab.label}</span>

                                    {/* Active Indicator */}
                                    {isActive && (
                                        <span
                                            className="absolute bottom-0 left-0 right-0 h-[2px] rounded-t-full"
                                            style={{
                                                backgroundColor: COLORS.primaryColor,
                                            }}
                                        />
                                    )}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* Content Area */}
                {renderContent()}
            </div>

            <Toaster position="bottom-center" />

            {/* Bottom Navigation - Hidden on desktop (lg and above) */}
            <div className="lg:hidden">
                <BottomNav />
            </div>

            <style>
                {`
                    .active\\:scale-98:active { transform: scale(0.98); }
                    .active\\:scale-95:active { transform: scale(0.95); }
                `}
            </style>
        </SidebarHeader>
    );
}

export default Services;